import { createSlice } from "@reduxjs/toolkit";
import { pipSaveProfile, pipSetAccessToken } from "../../utils/pip";
import {
  authForgotPassword,
  authLogin,
  authSignUp,
  fetchConditions,
  fetchFaq,
  fetchPolicy,
  fetchProfile,
  fetchSubscriptions,
  resetCurrentPassword,
  updateProfile,
  varifyForgotPassOtp,
  varifyOtp,
} from "../actions/authAction";

const initialState = {
  isLoading: false,
  isFaqLoading: false,
  isToggle: false,
  myPlanDetail: {},
  contentData: {},
  faqList: [],
};

export const authSlice = createSlice({
  name: "Auth",
  initialState: initialState,
  reducers: {
    toggleChange: (state, action) => {
      state.isToggle = action?.payload;
    },
  },
  extraReducers: (builder) => {
    // auth-login
    builder.addCase(authLogin.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(authLogin.fulfilled, (state, action) => {
      const { token, user } = action?.payload || "";
      token && pipSetAccessToken(token);
      user && pipSaveProfile(user);
      state.isLoading = false;
    });
    builder.addCase(authLogin.rejected, (state, action) => {
      state.isLoading = false;
    });
    // auth-sign-up
    builder.addCase(authSignUp.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(authSignUp.fulfilled, (state, action) => {
      state.isLoading = false;
    });
    builder.addCase(authSignUp.rejected, (state, action) => {
      state.isLoading = false;
    });
    // varify-otp
    builder.addCase(varifyOtp.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(varifyOtp.fulfilled, (state, action) => {
      state.isLoading = false;
    });
    builder.addCase(varifyOtp.rejected, (state, action) => {
      state.isLoading = false;
    });
    // auth-forgot-password
    builder.addCase(authForgotPassword.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(authForgotPassword.fulfilled, (state, action) => {
      state.isLoading = false;
    });
    builder.addCase(authForgotPassword.rejected, (state, action) => {
      state.isLoading = false;
    });
    //  varify-forgot-password-otp
    builder.addCase(varifyForgotPassOtp.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(varifyForgotPassOtp.fulfilled, (state, action) => {
      state.isLoading = false;
    });
    builder.addCase(varifyForgotPassOtp.rejected, (state, action) => {
      state.isLoading = false;
    });
    //  reset-current-password
    builder.addCase(resetCurrentPassword.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(resetCurrentPassword.fulfilled, (state, action) => {
      state.isLoading = false;
    });
    builder.addCase(resetCurrentPassword.rejected, (state, action) => {
      state.isLoading = false;
    });

    // fetch-profile
    builder.addCase(fetchSubscriptions.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(fetchSubscriptions.fulfilled, (state, action) => {
      const { myPlan } = action?.payload ?? {};
      state.myPlanDetail = myPlan || {};
      state.isLoading = false;
    });
    builder.addCase(fetchSubscriptions.rejected, (state, action) => {
      state.isLoading = false;
    });

    // update-profile
    builder.addCase(updateProfile.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(updateProfile.fulfilled, (state, action) => {
      const response = action?.payload ?? {};
      const updatedUser =
        response?.user || response?.data || response?.updatedUser || null;

      if (updatedUser) {
        pipSaveProfile(updatedUser);
      }

      state.isLoading = false;
    });
    builder.addCase(updateProfile.rejected, (state, action) => {
      state.isLoading = false;
    });
    // fetch-profile
    builder.addCase(fetchProfile.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(fetchProfile.fulfilled, (state, action) => {
      const response = action?.payload ?? {};
      const updatedUser = response?.user || null;

      if (updatedUser) {
        pipSaveProfile(updatedUser);
      }

      state.isLoading = false;
    });
    builder.addCase(fetchProfile.rejected, (state, action) => {
      state.isLoading = false;
    });
    // fetch-faq
    builder.addCase(fetchFaq.pending, (state, action) => {
      state.isFaqLoading = true;
    });
    builder.addCase(fetchFaq.fulfilled, (state, action) => {
      const {data} = action?.payload ?? {};
      state.faqList = data || [];
      state.isFaqLoading = false;
    });
    builder.addCase(fetchFaq.rejected, (state, action) => {
      state.isFaqLoading = false;
    });
    // fetch-policy
    builder.addCase(fetchPolicy.pending, (state, action) => {
      state.isFaqLoading = true;
    });
    builder.addCase(fetchPolicy.fulfilled, (state, action) => {
      const {data} = action?.payload ?? {};
      state.contentData = data || {};
      state.isFaqLoading = false;
    });
    builder.addCase(fetchPolicy.rejected, (state, action) => {
      state.isFaqLoading = false;
    });
    // fetch-conditions
    builder.addCase(fetchConditions.pending, (state, action) => {
      state.isFaqLoading = true;
    });
    builder.addCase(fetchConditions.fulfilled, (state, action) => {
  const {data} = action?.payload ?? {};
      state.contentData = data || {};
      state.isFaqLoading = false;
    });
    builder.addCase(fetchConditions.rejected, (state, action) => {
      state.isFaqLoading = false;
    });

    // // auth-forgot-password
    // builder.addCase(authForgotPassword.pending, (state, action) => {
    //   state.isLoading = true;
    // });
    // builder.addCase(authForgotPassword.fulfilled, (state, action) => {
    //   state.isLoading = false;
    // });
    // builder.addCase(authForgotPassword.rejected, (state, action) => {
    //   state.isLoading = false;
    // });

    // // update-profile
    // builder.addCase(updateProfile.pending, (state, action) => {
    //   state.isLoading = true;
    // });
    // builder.addCase(updateProfile.fulfilled, (state, action) => {
    //   state.isLoading = false;
    // });
    // builder.addCase(updateProfile.rejected, (state, action) => {
    //   state.isLoading = false;
    // });

    // // auth-change-password
    // builder.addCase(changePassword.pending, (state, action) => {
    //   state.isLoading = true;
    // });
    // builder.addCase(changePassword.fulfilled, (state, action) => {
    //   state.isLoading = false;
    // });
    // builder.addCase(changePassword.rejected, (state, action) => {
    //   state.isLoading = false;
    // });

    // // getDashboardData
    // builder.addCase(getDashboardData.pending, (state, action) => {
    //   state.isLoading = true;
    // });
    // builder.addCase(getDashboardData.fulfilled, (state, action) => {
    //   const { data } = action.payload ?? {};
    //   state.dashboardCount = {
    //     get_clinics: data?.get_clinics || 0,
    //     get_doctors: data?.get_doctors || 0,
    //     get_earnings: data?.get_earnings || 0,
    //     get_users: data?.get_users || 0,
    //   };
    //   state.clinicData = data?.latest_clinic || [];
    //   state.isLoading = false;
    // });
    // builder.addCase(getDashboardData.rejected, (state, action) => {
    //   state.isLoading = false;
    // });

    // // fetch-profile
    // builder.addCase(fetchNotification.pending, (state, action) => {
    //   state.isLoading = true;
    // });
    // builder.addCase(fetchNotification.fulfilled, (state, action) => {
    //   const { data, success } = action?.payload ?? {};
    //   state.notificationList = data || [];
    //   state.isLoading = false;
    // });
    // builder.addCase(fetchNotification.rejected, (state, action) => {
    //   state.isLoading = false;
    // });

    // // delete-notifications
    // builder.addCase(deleteNotifications.pending, (state, action) => {
    //   state.isLoading = true;
    // });
    // builder.addCase(deleteNotifications.fulfilled, (state, action) => {
    //   state.isLoading = false;
    // });
    // builder.addCase(deleteNotifications.rejected, (state, action) => {
    //   state.isLoading = false;
    // });
  },
});

export const { toggleChange } = authSlice.actions;
export default authSlice.reducer;
